import { AuthGuard, lazyLoad, NonAuthGuard, RouteExtended } from '@controladad/ng-base';

export const appRoutes: RouteExtended[] = [
  {
    path: 'login',
    loadComponent: () => lazyLoad(import('@admin/pages/login/login.component')),
    canActivate: [NonAuthGuard],
  },
  {
    path: '',
    layout: 'main',
    loadComponent: () => lazyLoad(import('@admin/layouts'), (t) => t.MainLayoutComponent),
    canActivateChild: [AuthGuard],
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'base/users', pathMatch: 'full' },
      {
        path: 'base',
        view: {
          label: 'اطلاعات پایه',
          icon: { default: 'base', active: 'base' },
        },
        children: [
          {
            path: 'users',
            view: {
              label: 'کاربران',
              icon: 'users',
            },
            permissions: 'ViewUsers',
            loadComponent: () => lazyLoad(import('@admin/pages/base/users/users.component')),
          },
          {
            path: 'personnel',
            view: {
              label: 'تحویل گیرنده',
              icon: { default: 'personnel', active: 'personnel' },
            },
            permissions: 'ViewPersonnel',
            loadComponent: () => lazyLoad(import('@admin/pages/base/personnel/personnel.component')),
          },
          {
            path: 'handhelds',
            view: {
              label: 'هندهلد',
              icon: { default: 'handheld', active: 'handheld' },
            },
            permissions: 'ViewHandhelds',
            loadComponent: () => lazyLoad(import('@admin/pages/base/handhelds/handhelds.component')),
          },
          {
            path: 'locations',
            view: {
              label: 'مکان ها',
              icon: { default: 'location', active: 'location' },
            },
            permissions: 'ViewLocations',
            loadComponent: () => lazyLoad(import('@admin/pages/base/locations/locations.component')),
          },
          {
            path: 'location-tags',
            view: {
              label: 'مکان-تگ',
              icon: { default: 'location', active: 'location' },
            },
            permissions: 'ViewLocationTags',
            loadComponent: () => lazyLoad(import('@admin/pages/base/location-tags/location-tags.component')),
          },
          {
            path: 'properties',
            view: {
              label: 'دارایی',
              icon: { default: 'properties', active: 'properties' },
            },
            permissions: 'ViewProperties',
            loadComponent: () => lazyLoad(import('@admin/pages/base/properties/properties.component')),
          },
          {
            path: 'property-tags',
            view: {
              label: 'دارایی-تگ',
              icon: { default: 'barcode', active: 'barcode' },
            },
            permissions: 'ViewPropertyTags',
            loadComponent: () => lazyLoad(import('@admin/pages/base/property-tags/property-tags.component')),
          },
          {
            path: 'roles',
            view: {
              label: 'نقش',
              icon: { default: 'role', active: 'role' },
            },
            permissions: 'ViewRoles',
            loadComponent: () => lazyLoad(import('@admin/pages/base/roles/roles.component')),
          },
        ],
      },
      {
        path: 'asset-tracking',
        view: {
          label: 'اموال گردانی',
          icon: { default: 'assets', active: 'assets' },
        },
        children: [
          {
            path: 'plans',
            view: {
              label: 'برنامه اموال گردانی',
              icon: { default: 'assets', active: 'assets' },
            },
            permissions: 'ViewPlans',
            loadComponent: () => lazyLoad(import('@admin/pages/asset-tracking/plans/plans.component')),
          },
          {
            path: ':id',
            permissions: 'ViewPlanAssetAudits',
            loadComponent: () => lazyLoad(import('@admin/pages/asset-tracking/plans/plan-asset-tracking-report/plan-asset-tracking-report.component')),
          },
        ],
      },
      {
        path: 'reports',
        view: {
          label: 'گزارشات',
          icon: { default: 'report', active: 'report' },
        },
        children: [
          {
            path: 'asset-tracking',
            view: {
              label: 'اموال گردانی',
              icon: { default: 'report', active: 'report' },
            },
            permissions: 'ViewAssetAuditReports',
            loadComponent: () => lazyLoad(import('@admin/pages/reports/asset-tracking-report/asset-tracking-report.component')),
          },
          {
            path: 'discovered-properties',
            view: {
              label: 'دارایی کشف شده',
              icon: { default: 'properties', active: 'properties' },
            },
            permissions: 'ViewDiscoveredProperties',
            loadComponent: () =>
              lazyLoad(import('@admin/pages/reports/discovered-properties/discovered-properties.component')),
          },
        ],
      },
      {
        path: 'data-import',
        view: {
          label: 'بروز رسانی',
          icon: { default: 'refresh', active: 'refresh' },
        },
        children: [
          {
            path: 'update-data',
            view: {
              label: 'بروز رسانی اطلاعات',
              icon: { default: 'refresh', active: 'refresh' },
            },
            loadComponent: () => lazyLoad(import('@admin/pages/data-import/update-information/update-information.component')),
          },
        ],
      },
    ],
  },
];
